import { deleteOddsAdjustments } from "@/api/oddsAdjustments";
import { useMutation } from "@tanstack/react-query";

export const useDeleteOddsAdjustments = () => {
  return useMutation({
    mutationFn: deleteOddsAdjustments,
  });
};
